/** Return the "largest possible viewport" height in px.
 *
 * What is the "largest possible viewport" height?
 * https://developers.google.com/web/updates/2016/12/url-bar-resizing
 */
const getFullVh = () => {
  return document.querySelector('#measure-vh').clientHeight;
};

const keyframesFileIndex = {
  squeezeStart: 240,
  squeezeEnd: 330,
  squeezeReset: 410,
};
const squeezeFramesCount =
  keyframesFileIndex.squeezeReset - keyframesFileIndex.squeezeStart;

const keyframes = {
  squeeze: {
    end: 90,
    reset: 170,
  },
  default: {
    goPillow: 0,
    smallMightyOne: 60,
    smallMightyTwo: 120,
    concaveHead: 170,
    squeeze: 240,

    squeezing: 410,

    ergonomic: 470, //- 170,
    openCell: 520, //- 170,
    end: 630, //- 170,
  },
};

const squeezeFrames = [];

const frames = {
  squeeze: [],
  default: [],
};

let imageWidth = 1440;
let imageHeight = 900;

let isSqueezing = false;
let canThrow = false;

if (window.innerWidth > 768) {
  imageUrls = window.liquid__pillowFrames;
} else {
  imageUrls = window.liquid__pillowMobileFrames;
  imageWidth = 390;
  imageHeight = 844;
}

[...Array(690).keys()].map((item, index) => {
  const imageUrl = imageUrls[index];
  frames['default'].push(imageUrl);
});

const canvas = document.getElementById('pillow-canvas');
const context = canvas.getContext('2d');

const isMobile = window.innerWidth <= 768;
const ratio = imageWidth / imageHeight;
const frameCount = frames['default'].length;
const images = {};

const preloadImages = () => {
  for (const [key, group] of Object.entries(frames)) {
    group.forEach((frame, index) => {
      let src = frame;

      const img = new Image();
      img.src = src;
      (images[key] ?? (images[key] = [])).push(img);
    });
  }
};
preloadImages();

function getCanvasSize() {
  let [width, height] = [window.innerWidth, getFullVh()];
  let [scaledWidth, scaledHeight] = [height * ratio, width / ratio];

  if (scaledWidth > width) {
    width = scaledWidth;
  } else {
    height = scaledHeight;
  }

  if (isMobile) {
    width = window.innerWidth;
    height = scaledHeight;
  }

  return { width, height };
}

const initialFrame = window?.isHome ? 0 : keyframes['default'].squeeze;
const pillowFrames = {
  frame: initialFrame,
  squeeze: 0,
};

// const canvasRender = {
//   image: '',
// }

// console.log(pillowFrames);
let previousRender = '';
const render = (sequence) => {
  // console.log(sequence, pillowFrames);

  // const newRender = `${sequence}-${pillowFrames[sequence == 'default' ? 'frame' : 'squeeze']}`;
  // if( newRender == previousRender) {
  //   return;
  // }

  // previousRender = newRender;

  // console.log(sequence, canThrow);

  if (sequence == 'default') {
    canThrow = false;
  }

  if (isSqueezing && sequence != 'squeeze') {
    return;
  }

  if (!images[sequence]) {
    return;
  }

  // console.log(pillowFrames, sequence);

  const image =
    images[sequence][pillowFrames[sequence == 'default' ? 'frame' : 'squeeze']];

  context.clearRect(0, 0, canvas.width, canvas.height);

  context.drawImage(
    image,
    0,
    0,
    image.width,
    image.height,
    0,
    0,
    canvas.width,
    canvas.height,
  );
};

render('default');
images['default'][initialFrame].addEventListener('load', function () {
  render('default');

  setTimeout(function () {
    render('default');
  }, 1000);
});

const defaultFramesTl = gsap.timeline({
  defaults: {
    snap: 'frame',
    ease: 'none',
    duration: 1,
  },
  onUpdate: function () {
    render('default');
  },
});

const pauseDuration = 1;
const overlapDuration = 0.5;

let productShown = false;
let squeezePlayed = false;
let jigglePlayed = false;



if(window?.isHome) {
  defaultFramesTl
    .add('start')
  
    .to('.canvas-layer--go-pillow', {
      autoAlpha: 0,
    })
  
    .fromTo(
      pillowFrames,
      {
        frame: keyframes['default'].goPillow,
      },
      {
        frame: keyframes['default'].smallMightyOne,
      },
      '<',
    )
    .to(
      '.canvas-layer--small',
      {
        autoAlpha: 1,
      },
      `<+=${overlapDuration}`,
    )
    .add(function () {
      $('.pillow-rect--small-one').addClass('active');
    }, '<+=0.5')
  
    .to({}, { duration: pauseDuration })
    .add('slide-1')
  
    .to('.pillow-rect--small-one', {
      autoAlpha: 0,
    })
  
    .to(
      pillowFrames,
      {
        frame: keyframes['default'].smallMightyTwo,
      },
      '<+=0.8',
    )
  
    .to(
      '.pillow-rect--small-two',
      {
        autoAlpha: 1,
      },
      `<+=${overlapDuration}`,
    )
  
    .add(function () {
      $('.pillow-rect--small-two').addClass('active');
    }, '<+=0.5')
  
    .to({}, { duration: pauseDuration })
    .add('slide-2')
  
    .to('.canvas-layer--small', {
      autoAlpha: 0,
    })
  
    .to(
      pillowFrames,
      {
        frame: keyframes['default'].concaveHead,
      },
      '<+0.8',
    )
  
    .to(
      '.canvas-layer--concave',
      {
        autoAlpha: 1,
      },
      `<+=${overlapDuration}`,
    )
  
    .to({}, { duration: pauseDuration })

    .add('squeeze-start')

    .to('.canvas-layer--concave', {
      autoAlpha: 0,
    })
  
    .to(
      pillowFrames,
      {
        frame: keyframes['default'].squeeze,
      },
      '<',
    )
  
    .to(
      '.canvas-layer--memory-foam',
      {
        autoAlpha: 1,
      },
      `<+=${overlapDuration}`,
    )
  
    .to({}, { duration: pauseDuration })

} else {

  defaultFramesTl
    .to('.canvas-layer--go-pillow', {
      autoAlpha: 0,
      duration: 0,
    }, 0)
    .to('.canvas-layer--memory-foam',{
      autoAlpha: 1,
      duration: 0,
    },0)

}





defaultFramesTl

  .add('squeezing--start')

  .fromTo(pillowFrames, {
    frame: keyframes['default'].squeeze,
  }, {
    frame: keyframes['default'].squeezing,
    duration: 3,
  })

  .to({}, { duration: pauseDuration })
  .add('squeeze--end')

  .to('.canvas-layer--memory-foam', {
    autoAlpha: 0,
  })

  .to(
    pillowFrames,
    {
      frame: keyframes['default'].ergonomic,
    },
    '<',
  )
  .to('.canvas-layer--ergonomic', {
    autoAlpha: 1,
  })
  .add(function () {
    $('.pillow-rect__ergonomic-line').addClass('active');
  }, '<+=0.5')

  .to({}, { duration: pauseDuration })
  .add('slide-5')

  .to('.canvas-layer--ergonomic', {
    autoAlpha: 0,
  })

  .to(pillowFrames, {
    frame: keyframes['default'].openCell,
  })

  .to(
    '.canvas-layer--open-cell',
    {
      autoAlpha: 1,
      onComplete: () => {
        $('.pillow-rect__arrows-wrapper').addClass('active');
      },
    },
    `<+=${overlapDuration}`,
  )

  .to({}, { duration: pauseDuration })

  .add('slide-6')


  if( window?.isHome ) {
    defaultFramesTl
      .to('.canvas-layer--open-cell', {
        autoAlpha: 0,
      })
    
      .add(function () {
        jigglePlayed = true;
        jiggleTl.play();
      })
    
      .to(
        {},
        {
          duration: 4,
        },
      )
    
      .add('end');
  }






const mainProductTl = gsap.timeline({
  paused: true,
  defaults: {
    ease: 'power2.inOut',
    duration: 1.8,
    onComplete: function () {
      if (ST) {
        endAnimation(ST);
      }
    },
  },
});

mainProductTl
  .to('.pillow-anim__bg', {
    scale: 2,
    duration: 4,
  })

  .to(
    '.canvas-layer--get',
    {
      autoAlpha: 1,
    },
    '<+=0.5',
  )

  .to(
    '.pillow-get__image-wrapper',
    {
      scale: isMobile ? 1 : 0.9,
      yPercent: isMobile ? -10 : -5,
    },
    '<+=1.4',
  )

  .from(
    '.pillow-get__header, .pillow-get .pillow-atc > *',
    {
      stagger: 0.2,
      autoAlpha: 0,
      y: 15,
    },
    '<',
  )
  .to(
    '.pillow-anim__canvas',
    {
      autoAlpha: 0,
    },
    '<',
  )

  .add('main-product');




const jiggleTl = gsap.timeline({
  paused: true,
  defaults: {
    ease: 'none',
    snap: 'frame',
  },
  onUpdate: function () {
    // console.log({ pillowFrames });
    render('default');
  },
});

jiggleTl
  .fromTo(
    pillowFrames,
    {
      frame: keyframes['default'].openCell,
    },
    {
      frame: keyframes['default'].end,
      duration: 3.5,
    },
  )

  .to(
    {},
    {
      duration: 0.1,
      onStart: () => {
        productShown = true;
        mainProductTl.play();
      },
    },
  );




const accessoriesTl = gsap.timeline({
  paused: true,
  defaults: {
    ease: 'expo.out',
    duration: 1.8,
  },
});

accessoriesTl
  .to('.canvas-layer--get', {
    autoAlpha: 0,
    ease: 'expo.in',
    duration: 1,
  })
  .to(
    '.canvas-layer--accessories',
    {
      autoAlpha: 1,
      duration: 1,
    },
    '<',
  )
  .from(
    '.split-product',
    {
      autoAlpha: 0,
      x: 40,
      stagger: 0.4,
    },
    '<+=0.8',
  )
  .from(
    '.pillow-get__split-bg',
    {
      xPercent: () => (isMobile ? 0 : 100),
      autoAlpha: () => (isMobile ? 0 : 1),
    },
    '<',
  );

const slidesCount = window?.isHome ? 8 : 3;
// console.log({ slidesCount })
const ST = ScrollTrigger.create({
  trigger: '.pillow-anim__section',
  start: 'top top',
  end: `+=${getFullVh() *  slidesCount}px`,
  animation: defaultFramesTl,
  scrub: 2.5,
  // scrub: true,
  // scrub: 0.5,
  pin: true,
  anticipatePin: true,
  snap: {
    inertia: false,
    snapTo: 'labelsDirectional',
    delay: 0.5,
    duration: {
      min: 1,
      max: 4,
    },
  },
  toggleClass: {
    className: 'navbar--hide',
    targets: 'body'
  },
  onLeave: function () {
    if( window?.isHome ) {
      jiggleTl.play();
    }
  },
});

// const navST = ScrollTrigger.create({
//   trigger: '.pillow-anim__trigger',
//   start: 'top top+=200px',
//   end: `+=${ (getFullVh() *  slidesCount) + 200 }px`,
//   toggleClass: {
//     className: 'navbar--hide animation-playing',
//     targets: 'body'
//   }
// });



let animationEnded = false;
function endAnimation(self) {
  if (jigglePlayed == false) {
    jiggleTl.play();
  }

  if (animationEnded == false) {
    animationEnded = true;

    let start = self.start;
    self.scroll(self.start);
    self.disable();

    // add true
    self.animation.progress(1, true);
    ScrollTrigger.refresh();
    window.scrollTo(0, start);
  }
}

function updateCanvasSize() {
  const canvasSize = getCanvasSize();
  canvas.width = canvasSize.width;
  canvas.height = canvasSize.height;

  document.querySelectorAll('.js-canvas-size').forEach((el) => {
    el.style.height = canvasSize.height + 'px';
    el.style.width = canvasSize.width + 'px';
  });

  render('default');
}

updateCanvasSize();

document.addEventListener('DOMContentLoaded', function () {
  updateCanvasSize();
  $(window).on('resize load', function () {
    if (window.innerWidth > 767) {
      updateCanvasSize();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  $('.pillow-atc__options input').on('change', function () {
    const $this = $(this);
    const $parent = $(this).closest('.pillow-atc');
    const handle = $parent.data('product');
    const bgProp = $parent.data('bg-property');

    document.body.style.setProperty(bgProp, $this.data('swatch-color'));

    $(`[data-variant-toggle][data-variant-scope="${handle}"]`).removeClass(
      'active',
    );
    $(
      `[data-variant-toggle="${$this.val()}"][data-variant-scope="${handle}"]`,
    ).addClass('active');
  });

  $('.pillow-atc__add button').on('click', function (e) {
    e.preventDefault();

    const $this = $(this);
    const $parent = $(this).closest('.pillow-atc');
    const id = $('input:checked', $parent).val();

    $this.addClass('is-loading');

    window.liquidAjaxCart.cartRequestAdd(
      {
        items: [
          {
            id,
            quantity: 1,
          },
        ],
      },
      {
        lastComplete: function () {
          $this.removeClass('is-loading');

          if ($parent.hasClass('pillow-atc--main')) {
            $('body').removeClass('cart-drawer--show');

            setTimeout(function () {
              accessoriesTl.play();
              document.body.classList.add('pillow-anim--split');
            }, 1000);
          }
        },
      },
    );
  });
});
